<template>
<!-- 设备台账维保记录 -->
    <div>
        <el-form ref="formRef" :rules='formRules' :model="form" label-width="90px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select :disabled="true" v-model="form.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备名称" prop="deviceName" >            
                                <div style="display:flex">
                                        <el-input v-model="form.deviceName" disabled></el-input>
                                        <!-- <el-button type="primary" size="small" @click="choiceDevice" v-if="isEdit">选择</el-button>  -->
                                </div>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备类型" prop="deviceType">
                             <el-input v-model="form.deviceType" disabled></el-input>
                          </el-form-item>
                      </el-col>
                    
                      <el-col :span="8">
                          <el-form-item label="设备编号" prop="code" >
                              <el-input disabled v-model="form.code"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="所属部门" prop="deptName" >
                              <el-input disabled v-model="form.deptName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="存放位置" prop="areaName" >
                              <el-input disabled v-model="form.areaName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="维保人" prop="realUpkeepManName" >
                              <el-input placeholder="请输入 维保人" show-word-limit clearable v-model="form.realUpkeepManName" :disabled="!isEdit" maxlength="20"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height:54px" >
                          <el-form-item label="维保时间" prop="realUpkeepTime" style="width:100%" >
                             <el-date-picker
                             :disabled="!isEdit"
                             style="width:100%" 
                            v-model="form.realUpkeepTime"
                            type="datetime"
                            placeholder="请选择 日期时间"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>
                      
                      <el-col :span="8">
                          <el-form-item label="维保金额" prop="amount">  
                                  <!-- <el-input  class="input-money" :disabled="!isEdit" clearable  placeholder="请输入维修金额"  v-model="form.amount"  maxlength="12"
                                  /> -->
                                   <moneyInput v-model="form.amount" placeholder="请输入 维保金额" :disabled="!isEdit" template="append" style="width: 100%"  /> 
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="维保工时"  prop="serviceDuration" >
                              <ATime :isEdit="isEdit" :time='form.serviceDuration' @update="maintenanceTime"></ATime>
                              <!-- <el-input :disabled="!isEdit" clearable v-model="form.serviceHour" maxlength="5"></el-input> -->
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="合同名称" prop="contractName" >
                              <div style="display:flex">
                                        <el-input placeholder="请选择 合同" disabled v-model="form.contractName"></el-input>
                                        <el-button type="primary" size="small" @click="choiceConstract" v-if="isEdit">选择</el-button> 
                                </div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="合同编号" prop="contractCode"  >
                              <el-input disabled placeholder="请输入 合同编号" v-model="form.contractCode"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="维保单位" prop="partnerName"  >
                              <el-input disabled placeholder="请输入 维保单位" v-model="form.partnerName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8" v-if="form.orderCode">
                          <el-form-item label="工单编号" prop="orderCode" >
                              <el-input disabled placeholder="请输入 工单编号" v-model="form.orderCode"></el-input>
                          </el-form-item>
                      </el-col>
                       <el-col :span="24">
                          <el-form-item label="维保标准" prop="standardContent" >
                              <el-input disabled placeholder="请输入 维保标准" type="textarea" v-model="form.standardContent" :rows="4" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="备注" prop="description" >
                              <el-input placeholder="请输入 备注" :disabled="!isEdit" type="textarea" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="图片" prop="code" >
                              <VUpload message="提示：只能上传jgp/png文件，且" messageType="pre" :disabled="!isEdit" :fileList="form.attachList" :types="['jpg','png']">
                                  <!-- <template v-slot="tip">
                                      只能上传jgp/png文件，且不大于5MB，数量最多3张
                                  </template> -->
                              </VUpload>
                          </el-form-item>
                      </el-col>
                      
                </el-row>
          </el-form>
            <el-table
                                    :data="consumablesList"
                                    border
                                    style="width: 100%">
                                    <el-table-column
                                    type="index"
                                    label="序号"
                                    align='center'
                                    width="50"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                    prop="consumableName"
                                    label="耗材名称"
                                    min-width="150"
                                    align='center'
                                    >
                                    <template slot-scope="scope" >
                                        <div style="display:flex">
                                            <el-input placeholder="请选择 耗材名称" v-model="scope.row.consumableName" disabled></el-input>
                                            <el-button type="primary" size="small" @click="addConsumableObj(scope.$index)" v-if="isEdit">选择</el-button> 
                                        </div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="specification"
                                    label="规格"
                                    align='center'
                                    >
                                    <template slot-scope="scope" >
                                        <el-input placeholder="请输入 规格" v-model="scope.row.specification" disabled></el-input>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="vender"
                                    align='center'
                                    label="厂家">
                                    <template slot-scope="scope" >
                                        <el-input placeholder="请输入 厂家" v-model="scope.row.vender" disabled></el-input>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="consumePrice"
                                    align='center'
                                     min-width="100"
                                    label="单价">
                                    <template slot-scope="scope" >
                                      <moneyInput v-model="scope.row.consumePrice"  :disabled="!isEdit" template="append" style="width: 100%"  /> 
                                       
                                    </template>
                                    </el-table-column>
                                    
                                    <el-table-column
                                    prop="consumeNum"
                                    align='center'
                                    label="数量">
                                    <template slot-scope="scope" >
                                        <el-input placeholder="请输入 数量" v-model="scope.row.consumeNum" v-input-filter:number  :disabled="!isEdit" maxlength="10" ></el-input>
                                    </template>
                                    </el-table-column>
                                    
                                    <el-table-column
                                    prop="address"
                                    align='center'
                                    label="小计金额">
                                    <template slot-scope="scope" >
                                        <div class="money"><span>{{tool.money_format_allowvoid(scope.row.consumeNum*scope.row.consumePrice)  }}</span></div>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    v-if="isEdit"
                                    prop="address"
                                    align='center'
                                    label="操作">
                                    <template slot-scope="scope" >
                                            <el-button type="primary" size="small" @click="removeConsumable(scope.$index)" >删除</el-button>
                                            </template>
                                    </el-table-column>
                            </el-table>
           
            <div v-if="isEdit">
                <button class="btn" @click="addConsumable()">+</button>
            </div>
            <div class="btnArea" v-if="isEdit">
                <el-button size="small" type="primary" icon="el-icon-circle-plus-outline"  @click="submitRecord"   style="margin-right: 20px"
                  >{{model=='add'?'保存':'修改'}}</el-button
                >
                <el-button icon="el-icon-circle-close" size="small" @click="closeRecord">取消</el-button>
            </div>
            <!-- 选择设备对话框 -->
            <el-dialog
            title="选择设备"
            v-if="choiceDeviceDialogFlag"
            :visible.sync="choiceDeviceDialogFlag"
            append-to-body="true"
            width="80%"
            :before-close="handleClose">
            <choiceDevice @cancelOperate='cancelOperate' :projectId="this.form.projectId" @choiceData="getDevice"></choiceDevice>
            </el-dialog>
            <el-dialog
                title="选择合同"
                :visible.sync="choiceContractDialogFlag"
                v-if="choiceContractDialogFlag"
                width="70%"
                append-to-body="true"
                :before-close="handleClose">
             <!-- :projectId="form.projectId" -->
             <choiceContract @cancleOperate="contractCancleOperate" :projectId='this.form.projectId' @close='dialogClose'  @getConstract="getContract"></choiceContract>
             </el-dialog>
             <el-dialog
                title="选择耗材"
                :visible.sync="choiceConsumableFlag"
                v-if="choiceConsumableFlag"
                append-to-body="true"
                :before-close="handleClose">
             <!-- :projectId="form.projectId" -->
             <choiceConsumable @cancleOperate="consumableCancleOperate" :projectId='this.form.projectId' @close='dialogClose'  @choiceData="getConsumable"></choiceConsumable>
             </el-dialog>
    </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';

import { getkeepStandard,updateKeepDetail} from '@/api/crmedical/device/deviceKeepRecord';
import choiceConsumable from '@/components/consumable/choiceConsumable';
import choiceDevice from '@/components/device/deviceChoice';
import VUpload from '@/views/components/v-upload';
import choiceContract from '@/components/choiceContract/choiceDeviceContract';
import ATime from '@/components/aTime/index';
import { saveDeviceUpkeep} from '@/api/crmedical/device/addDevice';
import { async } from 'q';
export default {
  components: { VUpload, choiceContract, choiceDevice, choiceConsumable, ATime },
  props: {
    model:{
      default: 'add',
    },
    form: {
      default: {
        projectId: '',
        attachList: [],
        realRepairTime: '',
        amount:'',
        realUpkeepManName:''
      },
    },
    projectId: '',
    operateStatus: {
      default: true,
      type: Boolean,
    },
    isEdit: false,
    isAdd:{
      default:false
    },
    row:{},
     projectList:{default:[]},
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if(value){
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入小数点前9位后2位小数的金额'));
        }
      }else{
         callback();
      }
    };
    var serviceHourValidatePass = (rule, value, callback) => {
      this.$forceUpdate();
      console.log('yan维修时间', this.form.serviceHour);
      if (this.form.serviceHour && this.form.serviceHour != 0) {
        callback();
      } else {
        callback(new Error('请输入维保时间'));
      }
    };
    return {
      isUpdate: false,
      //判断是否为编辑
      operatConsumableIndex: undefined,
      choiceConsumableFlag: false, //选择耗材对话框
      choiceContractDialogFlag: false, //选择设备对话框
      choiceDeviceDialogFlag: false, //选择设备对话框
      consumable: {//耗材
        consumableId: '',
        consumableName: '',
        specification: '',
        vender: '',
        consumeNum: '',
        consumePrice: '',
      },
      consumablesList: [
        {
          consumableId: '',
          consumableName: '',
          specification: '',
          vender: '',
          consumeNum: '',
          consumePrice: '',
        },
      ],
      dialogVisible: false,
      dialogConstract: {},
      formRules: {
        deviceName: [{ required: true, message: '请选择设备', trigger: 'change' }],
        amount: [{ required: false, validator: validatePass, trigger: 'blur' }],
        realUpkeepTime: [{ required: true, message: '请选择维保时间', trigger: 'blur' }],
        // serviceHour: [{ required: false, validator: serviceHourValidatePass, trigger: 'blur' }],
        realUpkeepManName: [{ required: true, message: '请输入维保人', trigger: 'blur' }],
      },
    };
  },
  created() {
    if(this.projectList.length<=0){
          getProjectList().then((res) => {
            this.projectList = res.data;
          });
      }
    if (this.form.consumables) {
      this.consumablesList = this.form.consumables;
      this.isUpdate = true;
    }
    if(this.row){//表示新增
      console.log("整个设备的数据",this.row)
      if(this.row.id){
        console.log("??????")
        getkeepStandard({id:this.row.id}).then(({data})=>{
          console.log(data)
          if(data[0]){
           
            this.$set(this.form, 'standardContent', data[0].content);
          }
          console.log("form",this.form)
        })
      }
      this.form.projectId = this.projectId
      this.form.deviceId = this.row.id;
      this.$set(this.form, 'deviceName', this.row.name);
      //   this.form.deviceName = val.name
      this.form.areaName = this.row.areaName;
      this.form.deviceType = this.row.typeName;
      this.form.code = this.row.code;
      this.form.deptName = this.row.deptName;
      this.$set(this.form,'attachList',[])
    }
    console.log('全部的form', this.form);
  },
  methods: {
    consumableCancleOperate() {
      this.choiceConsumableFlag = false;
    },
    contractCancleOperate() {
      this.choiceContractDialogFlag = false;
    },
    projectIdChange() {
      this.$set(this.form, 'deviceName', '');

      // this.form.deviceId = '';
      // this.form.deviceType=''
      // this.form.code = '';
      // this.form.deptName = '';
      // this.form.areaName = '';

      // this.form.amount = '';
      // this.form.realRepairManName = '';
      // this.form.realRepairTime = '';
      // this.form.serviceHour = '';
      // this.form.attachList = [];
      // this.form.description = '';
      // this.form.deviceConsumables = [];
      // this.form.partnerName = '';
      // this.form.contractName = '';
      // this.form.contractId = '';
      this.form = Object.assign({}, this.form, {
        deviceName: '',
        deviceId: '',
        deviceType: '',
        code: '',
        deptName: '',
        areaName: '',
        amount: '',
        realUpkeepManName: '',
        realUpkeepTime: '',
        serviceDuration: '',
        attachList: [],
        description: '',
        deviceConsumables: [],
        partnerName: '',
        contractName: '',
        contractId: '',
        signDept:'',
        standardContent:''
      });
      this.consumablesList = [
        {
          consumableId: '',
          consumableName: '',
          specification: '',
          vender: '',
          consumeNum: '',
          consumePrice: '',
        },
      ];
      this.$forceUpdate();
    },
    cancelOperate() {
      this.choiceDeviceDialogFlag = false;
    },
    maintenanceTime(date) {
      //维修完成时间

      this.$set(this.form, 'serviceDuration', Number(date.hour) * 60 + Number(date.minutes));
      // this.form.serviceHour =Number(date.hour)*60 + Number(date.minutes);
      console.log('维修时间', this.form.serviceDuration);
    },
    getConsumable(val) {
      console.log(val);
      let flag = false;
      this.consumablesList.forEach((element) => {
        if (element.consumableId == val.id) {
          console.log('是重复的');
          this.$message({
            message: '该耗材已经存在！',
            type: 'warning',
          });
          flag = true;
        }
      });
      if (!flag) {
        this.consumablesList[this.operatConsumableIndex].specification = val.specification;
        this.consumablesList[this.operatConsumableIndex].consumableId = val.id;
        this.consumablesList[this.operatConsumableIndex].consumePrice = val.price;
        this.consumablesList[this.operatConsumableIndex].consumeNum = 1;
        this.consumablesList[this.operatConsumableIndex].vender = val.vender;
        this.consumablesList[this.operatConsumableIndex].consumableName = val.name;
        this.operatConsumableIndex = undefined;
      }
      this.choiceConsumableFlag = false;
    },
    submitRecord() {
      let arry = [];
      //耗材删除为空的
      this.consumablesList.forEach((item) => {
        if (item.consumableId) {
          arry.push(Object.assign({}, item));
        }
      });
      this.consumablesList = arry;
      console.log(this.form);
      this.$refs['formRef'].validate(async(valid) => {
        if (valid) {
          if (this.isUpdate) {
          await  updateKeepDetail(
              Object.assign({}, this.form, { consumables: this.consumablesList })
            )
              .then((result) => {
                this.$message.success('修改成功');
                
              })
              .catch(() => {
                this.$message.error('修改失败');
              });

            this.$emit('submitOver');
          } else {
            saveDeviceUpkeep(
              Object.assign({}, this.form, { consumables: this.consumablesList })
            )
              .then((result) => {
                this.$message.success('新增成功');
                this.$emit('submitOver');
              })
              .catch(() => {
                this.$message.error('新增失败');
              });
            
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getDevice(val) {
      console.log(val);
      this.form.deviceId = val.id;
      this.$set(this.form, 'deviceName', val.name);
      //   this.form.deviceName = val.name
      this.form.areaName = val.areaName;
      this.form.deviceType = val.typeName;
      this.form.code = val.code;
      this.form.deptName = val.deptName;
      console.log("id",val.id)
      if(val.id){
        getkeepStandard({id:val.id}).then(({data})=>{
          console.log(data)
          if(data[0]){
           
            this.$set(this.form, 'standardContent', data[0].content);
          }
          console.log("form",this.form)
        })
      }
      this.choiceDeviceDialogFlag = false;
    },
    getContract(val) {
      console.log(val);
      this.form.contractId = val.id;
      this.form.contractName = val.name;
      this.form.partnerName = val.partnerName;
      this.form.signDept =val.signDept
      this.form.contractCode = val.code
      this.choiceContractDialogFlag = false;
    },

    choiceConstract() {
      this.choiceContractDialogFlag = true;
    },
    choiceDevice() {
      this.choiceDeviceDialogFlag = true;
    }, //添加耗材
    addConsumableObj(index) {
      this.operatConsumableIndex = index;
      console.log(this.operatConsumableIndex);
      this.choiceConsumableFlag = true;
    },
    //删除耗材
    removeConsumable(index) {
      let tagIndex = index;
      //   //找到删除下标
      //   for (let i = 0; i < this.consumablesList[i].length; i++) {
      //     if (this.consumablesList[i].index == row.index) {
      //       tagIndex = i;
      //       break
      //     }
      //   }
      this.consumablesList.splice(tagIndex, 1);
    },
    addConsumable() {
      this.consumable.index = ++this.consumable.index;
      this.consumablesList.push(Object.assign({}, this.consumable));
      console.log(this.consumablesList);
    },
    closeRecord() {
      this.$emit('cancelOperate');
    },
    dialogClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: right;
}
::v-deep .input-money .el-input__inner {
  text-align: right;
}
::v-deep .input-money .el-input__inner:-ms-input-placeholder {
  text-align: left;
}

::v-deep .input-money .el-input__inner::-webkit-input-placeholder {
  text-align: left;
}

::v-deep .input-money .el-input__inner::-moz-input-placeholder {
  text-align: left;
}
</style>
